export enum Permission {
  // ───────────────────────────────────────────────────────────────────
  // MOBILE / FIELD APP  (drivers & collection crews)
  // A role must have ALL THREE of the first three permissions for the
  // mobile field app to be usable (see mobile `hasFieldAppAccess`).
  // Add new mobile-app permissions in this block.
  // ───────────────────────────────────────────────────────────────────
  SUBMIT_REPORT = 'Submit report',
  VIEW_SUBMITTED_REPORT = 'View submitted report',
  VIEW_BIN_LOCATIONS = 'View bin locations',
  REPORT_ISSUES = 'Report issues',

  // ───────────────────────────────────────────────────────────────────
  // SHARED  (mobile + web)
  // ───────────────────────────────────────────────────────────────────
  EDIT_REPORT = 'Edit report',

  // ───────────────────────────────────────────────────────────────────
  // WEB / OFFICE (ADMIN PORTAL)
  // Requires ADMIN_PORTAL to log into the web portal. Grouped by module.
  // ───────────────────────────────────────────────────────────────────

  // Collections / Reporting
  VIEW_REPORTS = 'View reports',
  APPROVE_REPORTS = 'Approve reports',
  EXPORT_COLLECTION = 'Export collection',
  DELETE_REPORT = 'Delete report',
  VIEW_ANALYTICS = 'View analytics',

  // User management
  VIEW_USERS = 'View users',
  CREATE_USER = 'Create user',
  EDIT_USER = 'Edit user',
  DELETE_USER = 'Delete user',

  // Driver management
  ASSIGN_DRIVER = 'Assign driver role',
  EDIT_DRIVER_PERMISSIONS = 'Edit driver permissions',
  VIEW_DRIVER_ACTIVITY = 'View driver activity',
  DELETE_DRIVER = 'Delete driver',

  // Site management
  VIEW_SITES = 'View sites',
  CREATE_SITE = 'Create site',
  EDIT_SITE = 'Edit site',
  DELETE_SITE = 'Delete site',

  // Site schedules
  VIEW_SITES_SCHEDULE = 'View sites schedule',
  CREATE_SITE_SCHEDULE = 'Create site schedule',
  EDIT_SITE_SCHEDULE = 'Edit site schedule',
  DELETE_SITE_SCHEDULE = 'Delete site schedule',

  // Master data
  VIEW_MASTER_DATA = 'View master data',
  CREATE_MASTER_DATA = 'Create master data',
  EDIT_MASTER_DATA = 'Edit master data',
  DELETE_MASTER_DATA = 'Delete master data',

  // System & access
  MANAGE_SYSTEM_SETTINGS = 'Manage system settings',
  ADMIN_PORTAL = 'Admin portal',
}
